import React from "react";
import whistleBlowing from "../../../assets/img/whistle-blowing/whistle-blowing.png";

function WhistleBlowingSection() {
    return (
        <>
            <div className="container-whistleblowing">
                <div className="text-area">
                    <h3><b>Segera Laporkan!</b></h3>
                    <p>Jika Anda melihat dan/atau mendengarkan tindakan pelanggaran yang melawan hukum dan etika yang
                        dilakukan oleh pihak Danai.id. Kami menjamin kerahasiaan informasi dan identitas pelapor dengan
                        aman.</p>
                    <a href="/whistle-blowing" className="btn-danai red-outline">Pelajari Lebih Lanjut</a>
                </div>
                <img src={whistleBlowing} alt="whistleBlowing"/>
            </div>
        </>
    );
}

export default WhistleBlowingSection;